import { render, staticRenderFns } from "./tzNotice.vue?vue&type=template&id=5776cf80&scoped=true&"
import script from "./tzNotice.vue?vue&type=script&lang=js&"
export * from "./tzNotice.vue?vue&type=script&lang=js&"
import style0 from "./tzNotice.vue?vue&type=style&index=0&id=5776cf80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5776cf80",
  null
  
)

export default component.exports